<div class="toast bg-{{toast.color}} fade in show" role="alert" *ngFor="let toast of toasts">
  <div class="toast-header bg-{{toast.color}} py-2 px-4">
    <strong class="mr-auto text-white">
      <ng-container [ngSwitch]="toast.color">
        <ng-container *ngSwitchCase="'danger'">
          <ng-container [ngSwitch]="toast.message">
            <span *ngSwitchCase="'Unauthorized'">You are not allowed to perform this action.</span>
            <span *ngSwitchCase="'form-invalid'">Please fix all the errors on this page.</span>
            <span *ngSwitchCase="'signature-required'"></span>
            <span *ngSwitchCase="'vehicles-license-already-taken'">A vehicle with the same license plate already exists.</span>
            <span *ngSwitchCase="'vehicles-has-permit-request'">This vehicle already has an active Permit Request.</span>
            <span *ngSwitchCase="'users-email-already-taken'">Email already taken.</span>
            <span *ngSwitchCase="'insufficient-balance'">You have insufficient funds to buy this item.</span>
            <span *ngSwitchDefault>
              <span *ngIf="toast.showRawMessage">{{toast.message}}</span>
              <span [hidden]="toast.showRawMessage">An unkown error occured. Please try again later.</span>
            </span>
          </ng-container>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <span *ngIf="toast.showRawMessage">{{toast.message}}</span>
          <span [hidden]="toast.showRawMessage">An unkown error occured. Please try again later.</span>
        </ng-container>
      </ng-container>
    </strong>
    <button type="button" class="ml-2 mb-1 close text-white"
      (click)="dismiss(toast)"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>
